import Entity from '../entity';
import FlightClass from './flightClass';
import FlightSegment from './flightSegment';
import FlightPriceGeneral from './flightPriceGeneral';
import FlightQuota from './flightQuota';
import FlightSaleChannel from './flightSaleChannel';
import PassengerType from '../passengerType';
export default class FlightPrice extends Entity<string> {
  flightId: string;
  flightClassId: string;
  flightClass: FlightClass;
  flightSegmentId: string;
  flightSegment: FlightSegment;
  totalQuota: number;
  flightQuotas: FlightQuota[];
  isDeleted: boolean;
  deleterUserId: any;
  deletionTime: any;
  lastModificationTime: any;
  lastModifierUserId: any;
  creationTime: string;
  creatorUserId: number;
  flightPriceGenerals: FlightPriceGeneral[];
  passengerType: PassengerType;
  salesChannel: FlightSaleChannel;
  flightPriceId: string;
  pricePassengerTypeId: number;
  oneWayPrice: string;
  roundTripPrice: string;
  minAge: string | number;
  maxAge: string | number;
  quota: string;
  endUserOwPrice: number;
  endUserRtPrice: number;
  agencyOwPrice: number;
  agencyRtPrice: number;
  salesChannelId: string;
  paxCount: number;
  flightPriceSpecials: any;
  isGroup: boolean;
  currencyId: any;
  baggage: number;
  pricePassengerType: string;
}
